module.exports = __webpack_public_path__ + "static/media/holiday-1.483efbaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/partner-hotels/holiday-inn-bangkok/holiday-1.jpg
// module id = 722
// module chunks = 6